import { useNavigate } from "react-router-dom";
import { NOT_FOUND_MESSAGE } from "./notFoundData";

import "./index.scss";

const NotFound = ({ reason = "route" }) => {
  const navigate = useNavigate();

  const { title, description } = NOT_FOUND_MESSAGE(reason);

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">Oops!</h1>
        <h2 className="not-found-subtitle">{title}</h2>
        <p className="not-found-description">{description}</p>
        <button className="not-found-button" onClick={() => navigate(-1)}>
          Go Back
        </button>
      </div>
      <div className="not-found-background"></div>
    </div>
  );
};

export default NotFound;
